<div class="customer-list-container">
  <form class="customer-list--search px-3">
    <mat-form-field class="customer-list--search-field" color="primary" appearance="outline">
      <input
        [formControl]="searchString"
        matInput
        name="search"
        placeholder="Søg i fonde"
        autocomplete="off"
        >
      <button matSuffix mat-button><mat-icon>search</mat-icon></button>
    </mat-form-field>
  </form>
  @if (loading) {
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  }
  <mat-divider></mat-divider>
  @if (filteredCustomerList$ | async; as filteredCustomerList) {
    <mat-list class="customer-list pt-0">
      @for (customer of filteredCustomerList; track customer) {
        <mat-list-item @fadeInSlow
          class="customer-list-item"
          routerLinkActive="active"
          routerLink="/customers/{{customer.id}}/"
          >
          <mat-icon matListItemIcon [ngClass]="'status-' + customer.status">circle</mat-icon>
          <h4 matListItemTitle>{{customer.name}}</h4>
          <small matListItemLine><em>{{customer.subdomain}}</em></small>
        </mat-list-item>
        <mat-divider></mat-divider>
      }
      @if (filteredCustomerList.length === 0) {
        <mat-list-item>
          <mat-icon matListItemIcon>search_off</mat-icon>
          <h4 matListItemTitle>Ingen matches.</h4>
          <p matListItemLine>Ingen fonde matcher <em>{{searchString.value}}</em>. Prøv noget andet.</p>
        </mat-list-item>
      }
    </mat-list>
  }
</div>
